import {
  createFileRoute,
  useNavigate,
  useRouterState,
} from '@tanstack/react-router';
import { useCallback, useEffect, useRef } from 'react';
import {
  useFnBatchCreateControllerCreateBatch,
  useFnBatchCreateControllerGetLatestBatch,
} from '@/generated/api/fn-batch-create.ts';
import LoaderAppShell from '@/common/components/LoaderAppShell.tsx';

export const Route = createFileRoute('/work-orders/create/')({
  component: RouteComponent,
  staticData: {
    authorization: {
      permission: {
        workOrder: ['write'],
      },
    },
  },
});

function RouteComponent() {
  const navigate = useNavigate();
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  });
  const handlingBatchRerouteRef = useRef(false);
  const latestBatch = useFnBatchCreateControllerGetLatestBatch();
  const createBatch = useFnBatchCreateControllerCreateBatch();

  const getOrCreateBatch = useCallback(async () => {
    if (pathname !== '/work-orders/create') return;
    if (handlingBatchRerouteRef.current) return;
    if (latestBatch.data === undefined) return;

    try {
      handlingBatchRerouteRef.current = true;

      if (latestBatch.data.batch !== null) {
        void navigate({
          replace: true,
          to: '/work-orders/create/$batchId',
          params: { batchId: latestBatch.data.batch.id },
        });
        return;
      }

      const batch = await createBatch.mutateAsync();
      void navigate({
        replace: true,
        to: '/work-orders/create/$batchId',
        params: { batchId: batch.id },
      });
    } catch (error) {
      handlingBatchRerouteRef.current = false;
      throw error;
    }
  }, [pathname, latestBatch.data, createBatch, navigate]);

  useEffect(
    () => void getOrCreateBatch(),
    [getOrCreateBatch, latestBatch.data],
  );

  return <LoaderAppShell text={'Loading batch...'} />;
}
